import React from 'react';
import YouTube from 'react-youtube';

const VideoPlayer = ({ id }) => {
  const _onReady = event => {
    // event.target.mute();
  };

  const _onEnd = event => {
    event.target.playVideo();
  };

  const videoOptions = {
    playerVars: {
      autoplay: 0,
      controls: 0,
      rel: 0,
      showinfo: 0
    }
  };

  return (
    <YouTube
      videoId={id}
      opts={videoOptions}
      className="video-iframe"
      onReady={_onReady}
      onEnd={_onEnd}
    />
  );
};

export default VideoPlayer;
